<template lang="pug">

  transition

    #emotional-meter

      div.top(ref="top")
        p {{title}}
        div.inner
          div.arrow(ref="arrow")
            span {{score}}
            div.line
          ul(ref="list")
            li 
              p.start(ref="start") 0%
            li
            li
            li
            li
            li
            li
            li
            li
            li
            li 
              p.end(ref="end") 100%

      div.bait(ref="bait")
        p.bait-inner(ref="baitinner") {{result.bait}}


</template>

<script>

import { mapState, mapMutations } from 'vuex' 
import TweenMax from 'gsap' 
import { map, clamp } from '@/helpers/MathUtils'

export default {

  name: 'emotional-meter',
  
  components: {},
  
  data() {
    return {
      title : '',
      x: 0,
      score: 0,
      tweenObj: {
        ratio: 0
      }
    }
  },
  
  computed: {

    ...mapState('question', [
      'STATES', 
      'state', 
      'result',
      'targetIndex',
      'GOALS'
    ]) 
  },
  
  mounted() {},
  
  beforeDestroy() {},
  
  methods: {

    onUpdate(){

      TweenMax.set(this.$refs.arrow, {
        'x': Math.abs(this.x * this.tweenObj.ratio)
      });
 
      this.score = parseInt( this.result.percentage * this.tweenObj.ratio) + '%';

    },

    updateQuestionState(val){},

    hide() {
      TweenMax.to(this.$el, 1, {
        'autoAlpha': 0
      });
    },  

    show() { 
      TweenMax.set(this.$el,   {
        'autoAlpha': 1 
      });
      TweenMax.to(this.$refs.top, 0.8, { 
        'y': 0, 
        'delay': 1.2,
        'ease': 'Expo.easeOut'
      });
      TweenMax.to(this.$refs.baitinner, 0.8, { 
        'opacity': 1, 
        'delay': 2.5,
        'ease': 'Quad.easeOut'
      });
      TweenMax.to(this.$el, 1, { 
        'y': 0, 
        'delay': 1,
        'ease': 'Back.easeOut'
      });
      
      TweenMax.to([this.$refs.start, this.$refs.end], 1, { 
        'opacity': 1, 
        'y': 0, 
        'delay': 1.3,
        'ease': 'Sine.easeInOut'
      });
      TweenMax.fromTo(this.tweenObj, 4  , {
        ratio: 0
      }, {
        ratio: 1,
        onUpdate: this.onUpdate,
        'delay': 0.7,
        'ease': 'Expo.easeInOut'
      });

      TweenMax.staggerTo(this.$refs.list.children, 1, {
        y: 0,
        delay: 0.1,
        ease: 'Back.easeOut'
      }, 0.1);
    },
 
    updateTitle(){

      switch(this.targetIndex) {

        case this.GOALS.ANGRY:
            this.$refs.list.classList.add('angry');
            this.title = 'angriness index';
            break;

        case this.GOALS.SAD: 
            this.$refs.list.classList.add('sad');
            this.title = 'sadness index';
            break; 

        case this.GOALS.CONFUSED:
            this.$refs.list.classList.add('confused');
            this.title = 'confusedness index';
            break;

        case this.GOALS.HAPPY: 
            this.$refs.list.classList.add('happy');
            this.title = 'happiness index';
            break; 
      }
    }
  },
  
  watch: {

    'state'(val){
      if( 
        (val === this.STATES.COMPLETE) && 
        (this.result.index !== 9)
      ){
        this.updateTitle();
        this.show();
      } else {
        this.hide();
      }
    },

    'result.percentage'(val){ 
      
      let ratio = ( Math.abs(val) / 100);
      let width = this.$el.offsetWidth / window.devicePixelRatio;
      this.x = ratio * 200; 
 
    } 
  }

}

</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

#emotional-meter
  position : absolute;
  bottom: 2rem;
  width: calc(100% - 4rem);
  text-align: center;
  font-size: 1.3rem;
  visibilty: hidden; 
  transform: translateY(300px)
  padding-top: 1rem;
  overflow: hidden;

  .top
    padding-top: 1.5rem;
    background-color: #f8f8f8;
    transform: translate3d(0, 100%, 0);
    overflow: hidden;

  p
    margin: 0;
    position: relative;
    line-height: 1.6; 
    color: black;
    padding: 0;

  .bait
    background: #363333;
    margin: 0;
    padding: 1rem 0 2rem;
    z-index: 1;

    .bait-inner
      color: white;
      opacity: 0;
 
  .inner
    background-color: #f8f8f8; 
    width: 200px;
    margin: 0 auto;
    position: relative;
 
    .arrow
      border: solid #363333;
      border-width: 0 4px 4px 0;
      display: inline-block;
      padding: 3px;
      margin-bottom: 1rem;
      left: -5px;
      top: -20px;
      position: absolute;
      transform: rotate(45deg);
      z-index: 9999;

      span
        position: absolute;
        top: -1.5rem;
        left: -2.8rem;
        width: 5rem;
        transform: rotate(-45deg);


      .line
        width: 1px;
        background: #363333;
        transform: rotate(-45deg);
        transform-origin: 0% 0% 0;
        height: 80px;
        top: 7px;
        left: 6px;
        position: absolute;
 

    ul
      display: flex;
      justify-content: space-between;
      margin: 40px auto 0;

      li
        width: 2rem;
        height: 5rem;
        background: black;
        position: relative;
        transform: translate3d(0,100%,0);
        transition: transform 0.5s ease-in-out;

        .show
          transform: translate3d(0,0%,0);


        p
          margin: 0;

        p.start
          position: absolute;
          top: 0px; 
          font-size: 1.4rem;
          width: 6.5rem;
          left: -6.5rem;
          opacity: 0;
          transform: translate3d(0,50px,0);

        p.end
          position: absolute;
          top: 0px;
          font-size: 1.4rem;
          left: 2rem;
          width: 6.5rem;
          opacity: 0;
          transform: translate3d(0,50px,0);

        
      &.angry
        li
          &:nth-child(1)
            background: #b0afa2;
          &:nth-child(2)
            background: #b5a698;
          &:nth-child(3)
            background: #bc9b88;
          &:nth-child(4)
            background: #c48f77;
          &:nth-child(5)
            background: #ce8063;
          &:nth-child(6)
            background: #d86f4c;
          &:nth-child(7)
            background: #e26139;
          &:nth-child(8)
            background: #e95429;
          &:nth-child(9)
            background: #f04819;
          &:nth-child(10)
            background: #f73f0c;
          &:nth-child(11)
            background: #fc3600;

      &.sad
        li
          &:nth-child(1)
            background: #b0afa2;
          &:nth-child(2)
            background: #a8aaa8;
          &:nth-child(3)
            background: #9ca1b1;
          &:nth-child(4)
            background: #8e98ba;
          &:nth-child(5)
            background: #7d8dc7;
          &:nth-child(6)
            background: #6b82d3;
          &:nth-child(7)
            background: #5a78df;
          &:nth-child(8)
            background: #4e6fe8;
          &:nth-child(9)
            background: #4267f0;
          &:nth-child(10)
            background: #3660f9;
          &:nth-child(11)
            background: #2d59ff;

      &.happy
        li
          &:nth-child(1)
            background: #b0afa2;
          &:nth-child(2)
            background: #a7b4a1;
          &:nth-child(3)
            background: #9bbc9f;
          &:nth-child(4)
            background: #8dc49d;
          &:nth-child(5)
            background: #7dce9b;
          &:nth-child(6)
            background: #6cd999;
          &:nth-child(7)
            background: #5ae496;
          &:nth-child(8)
            background: #4eeb94;
          &:nth-child(9)
            background: #42f292;
          &:nth-child(10)
            background: #35f991;
          &:nth-child(11)
            background: #2dff90;

      &.confused
        li
          &:nth-child(1)
            background: #b0afa2;
          &:nth-child(2)
            background: #b5aaa7;
          &:nth-child(3)
            background: #bca2af;
          &:nth-child(4)
            background: #c499b9;
          &:nth-child(5)
            background: #ce90c3;
          &:nth-child(6)
            background: #d985cf;
          &:nth-child(7)
            background: #e27bda;
          &:nth-child(8)
            background: #ea73e2;
          &:nth-child(9)
            background: #f16ce9;
          &:nth-child(10)
            background: #f865f1;
          &:nth-child(11)
            background: #fc60f7;


</style>